import * as Immutable from 'seamless-immutable';
import {
  RECEIVE_API_DATA,
  RECEIVE_API_DATA_PROFILE,
  RECEIVE_FUSEBILL_DATA,
  RECEIVE_FUSEBILL_PAYMENT_METHOD,
  RECEIVE_FUSEBILL_CARD_ID,
  RECEIVE_BUSINESSUPDATE_DATA,
  RECEIVE_CONSUMERUPDATE_DATA,
  RECEIVE_BUSINESS_USER_DATA,
  RECEIVE_BUSINESS_USER_DATA_PARTNER,
  // RECEIVE_BUSINESS_USER_DATA_FIRST_STEP,
  RECEIVE_DEFENDENT_AUTO_DATA,
  RECEIVE_ALL_STATES,
  RECEIVE_FORGET_PASSWORD_DATA,
  RECEIVE_ALL_PLANES,
  RECEIVE_USER_EMAIL_DATA,
  RECEIVE_REQUEST_RESET_PASSWORD,
  RECEIVE_BUSINESS_DATA,
  RECEIVE_INDUSTRY_DATA,
  RECEIVE_SETTLEMENT_ENRICH_QUE,
  RECEIVE_ALL_SETTLEMENT,
  RECEIVE_ALL_CATEGORY,
  RECEIVE_SETTLEMENT_FOR_USER,
  RECEIVE_ALL_FEATURE_SETTLEMENT,
  RECEIVE_ALL_ATTENTION_SETTLEMENT,
  RECEIVE_ALL_COMPLETE_SETTLEMENT,
  RECEIVE_SAVE_ENRICHMENT_QUESTION,
  RECEIVE_CHILDCOMPAY_DATA,
  RECEIVE_CONSUMERUSER_DATA,
  RECEIVE_BUSINESSUSER_DATA,
  RECEIVE_BUSINESSUSER_DATA_AFFI,
  RECEIVE_PLAN_PRICE_CHANGE,
  RECEIVE_AFFILIATE_USER_TYPE_SIGNUP,
  RECEIVE_COGNITO_ID_BY_EMAIL,
  RECEIVE_CONFIRM_EMAIL_COGNITO,
  RECEIVE_VIEW_BUSINESSCOMPANY_DATA,
  RECEIVE_DELETE_BUSINESSCOMPANY_DATA,
  RECEIVE_BUSINESSCOMPANY_DATA,
  RECEIVE_BUSINESSCOMPANY_UPDATE_DATA,
  RECEIVE_COUNTRY_DATA,
  RECEIVE_STATEID_DATA,
  RECEIVE_CITYID_DATA,
  RECEIVE_AFFILIATE_DATA,
  RECEIVE_AFFILIATESUBUSER_DATA,
  RECEIVE_GET_ALL_GROUPS_BY_PARENT_AFFILIATE_USER,
  RECEIVE_GET_ALL_PARTNERS_BY_GROUP,
  RECEIVE_ALL_HIERARCHY_CHILD_AFFILIATE_USERS_BY_PARENT_AFFILIATE_USER,
  RECEIVE_GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER_FOR_GROUP,
  RECEIVE_BUSINESSSUBUSER_DATA,
  RECEIVE_CLEAR_BUSINESSSUBUSER_DATA,
  RECEIVE_ALL_CONSUMER_PLANES,
  RECEIVE_AFFILIATESUBUSERLIST_DATA,
  RECEIVE_DELETE_AFFILIATESUBUSER_DATA,
  RECEIVE_SETTLEMENT_QUESTION_ID,
  RECEIVE_PENDING_SETTLEMENT_QUESTION_ID,
  RECEIVE_SETTLEMENT_ANSWERS,
  RECEIVE_ENROLMENT_DOC,
  RECEIVE_UPDATE_ENROLMENT_DOC,
  RECEIVE_EMAIL_VERIFY,
  RECEIVE_AFFILIATE_USER_TYPE,
  RECEIVE_SUBUSERBYID_TYPE,
  RECEIVE_UPDATEAFFILIATESUBUSER_TYPE,
  RECEIVE_ENROLMENT_AUTH,
  RECEIVE_COMPLETED_SETTLEMENTS,
  RECEIVE_ALL_VEHICLE_DATA,
  RECEIVE_ALL_VEHICLE_DATA_SETTLEMENT,
  RECEIVE_NOTIFICATION_DATA,
  RECIEVE_MARK_NOTIFICATIONS,
  RECEIVE_CONSUMER_RESIDENCE,
  RECEIVE_ALL_VEHICLE_YEAR,
  RECEIVE_ALL_FILTEREDSETTLEMENT,
  RECEIVE_ALL_DASHBOARD_FILTEREDSETTLEMENT,
  RECEIVE_SAVE_MULTIPLE_VEHICLE_QUESTION_DATA,
  RECEIVE_VEHICLE_MAKE_DATA,
  RECEIVE_VEHICLE_MODEL_DATA,
  RECEIVE_VEHICLE_TRIM_DATA,
  RECEIVE_UPLOADFILE_DATA_DOC,
  RECEIVE_VEHICLE_DATA_USERID_DATA,
  RECEIVE_DELETE_VEHICLE_DATA_USERID_DATA,
  RECEIVE_VIEW_VEHICLE_DATA_USERID_DATA,
  RECEIVE_DELETE_CONSUMER_RESIDENCE,
  RECEIVE_VIEW_CONSUMER_RESIDENCE,
  RECEIVE_VEHICLE_SAVE_DATA,
  RECEIVE_SAVE_RESIDENCE_DATA,
  RECEIVE_ALL_ENROLLEDSETTLEMENT,
  RECEIVE_BUSINESSSUBUSERLIST_DATA,
  RECEIVE_DELETE_BUSINESSSUBUSER_DATA,
  RECEIVE_BUSINESSSUBUSERBYID_TYPE,
  RECEIVE_UPDATEBUSINESSSUBUSER_TYPE,
  RECEIVE_PENDING_DOCS,
  RECEIVE_DISMISS_SETTLEMENT,
  RECEIVE_FAQ_CATEGORY,
  RECEIVE_FAQ_QUESTIONS_BY_CATEGORY_ID,
  RECEIVE_PAGE_DATA,
  RECEIVE_PAGE_DATA_FOOTER,
  RECEIVE_PAGE_DATA_IDENTITY_KEY,
  RECEIVE_ACCEPT_DOCUMENT,
  RECEIVE_DISMISS_SETTLEMENT_FOR_USER,
  RECEIVE_UPLOADFILE_DATA,
  RECEIVE_QUESTION_TYPE_FILE,
  RECEIVE_QUESTION_TYPE_FILE_DELETE,
  RECEIVE_CHANGE_PASSWORD_DATA,
  RECEIVE_REGISTRATION_LINKS_FOR_USER,
  RECEIVE_SETTLEMENT_WITHOUT_DATA,
  RECEIVE_ALL_FILTEREDSETTLEMENT_AFFILIATE,
  RECEIVE_DETAIL_BYAFFILIATEKEY,
  RECEIVE_AFFILIATE_DASHBOARD_DATA,
  RECEIVE_GET_AFFILIATE_DASHBOARD_USER_FOR_PARENT,
  RECEIVE_ALL_REFERRED_FILTEREDSETTLEMENT_AFFILIATEID,
  RECEIVE_ALL_ENROLLED_FILTEREDSETTLEMENT_AFFILIATEID,
  RECEIVE_ALL_USER_SETTLEMENT_AFFILIATEID,
  RECEIVE_ALL_SETTLEMENT_LIST_OF_USER_BY_ID_FOR_GROUP,
  RECEIVE_BAR_DASHBOARD_DATA,
  RECEIVE_GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER,
  RECEIVE_MONTHLY_ENROLLMENTS_BY_AFFILIATE_GROUP,
  RECEIVE_PIE_DASHBOARD_DATA,
  RECEIVE_PIE_DASHBOARD_STATE_DATA,
  RECEIVE_UPDATE_AFFILIATE_DATA,
  RECEIVE_APPLY_NEXT_QUESTION,
  RECEIVE_SAVE_APPLY_NEXT_QUESTION,
  RECEIVE_ALL_ELIGIBILITY_BACK,
  RECEIVE_PENDING_DOCS_USER,
  RECEIVE_PENDING_DOCS_USER_DELETE,
  RECEIVE_CONSUMER_USER_DATA,
  RECIEVE_ALL_NOTIFICATIONS,
  RECEIVE_ACTIVITY_LOG,
  DELETE_NOTIFICATION_SUCCESS,
  RECEIVE_ALL_TOTAL_FUND_DATA,
  LOGOUT_USER,
  RECEIVE_ALL_SITE,
  RECEIVE_ALL_EXTERNAL_VEHICLE_DATA,
  RECEIVE_SAVE_MULTIPLE_VEHICLE_DATA,
  RECEIVE_ALL_PROMOTED_SETTLEMENT,
  RECIEVE_UPLOADED_CHILD_COMPANY,
  RECEIVE_AUTO_UPDATE_DATA,
  RECEIVE_DASHBOARD_DATA,
  RECEIVE_DASHBOARD_DATA_COUNT,
  RECEIVE_ALL_ENROLLED_AFFILIATEID,
  RECEIVE_FUSEBILL_COUNTRIES_DATA_FOR_CARD,
  SUCCESS,
  RECEIVE_AFFILIATE_RESOURCE,
  SET_PAGE_NAME,
  RECEIVE_TRANSACTIONS_HISTORY,
  RECEIVE_DEBIT_WALLET_BALANCE,
  LINK_ACCOUNT_PROFILE_PAGE,
  RECIEVE_LINK_ACCOUNT_PROFILE_PAGE,
  GET_TRANSCARD_PAYMENT_METHODS,
  RECIEVE_GET_TRANSCARD_PAYMENT_METHODS,
  RECEIVE_DISBURSE_AMOUNT,
  DISBURSE_AMOUNT,
  TRANSFER_FUNDS_TO_ACH,
  RECEIVE_TRANSFER_FUNDS_TO_ACH,
  TRANSFER_FUNDS_TO_CARD,
  RECEIVE_TRANSFER_FUNDS_TO_CARD,
  ADD_USER_BANK_ACCOUNT,
  RECIEVE_ADD_USER_BANK_ACCOUNT_PAGE,
  CLEAR_RECEIVE_ADD_USER_BANK_ACCOUNT_API,
  CLEAR_RECEIVE_ADD_USER_CARD,
  CLEAR_RECEIVE_ADD_BUSINESS_USER_CARD,
  GET_ADDED_BANK_ACCOUNT_FOR_USER,
  RECIEVE_GET_ADDED_BANK_ACCOUNT_FOR_USER,
  GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER,
  RECIEVE_GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER,
  GET_ALL_BANK_ACCOUNTS_FOR_USER,
  RECIEVE_GET_ALL_BANK_ACCOUNTS_FOR_USER,
  RECIEVE_GET_USER_TRANSACTION_HISTORY,
  DELETE_USER_BANK_ACCOUNT,
  RECEIVE_DELETE_USER_BANK_ACCOUNT,
  DELETE_USER_CARD,
  RECEIVE_DELETE_USER_CARD,
  SET_DEFAULT_BANK_ACCOUNT,
  RECEIVE_SET_DEFAULT_BANK_ACCOUNT,
  RECEIVE_SET_DEFAULT_CARD,
  SHOW_NET_AMOUNT_TO_USER,
  RECIEVE_SHOW_NET_AMOUNT_TO_USER,
  RECEIVE_UPDATE_BANK_ACCOUNT_DETAILS,
  UPDATE_CARD_DETAILS,
  RECEIVE_UPDATE_CARD_DETAILS,
  UPDATE_BANK_ACCOUNT_DETAILS,
  RECEIVE_GET_AFFILIATE_GROUP_SUCCESS,
  MARK_ALL_READ_NOTIFICATIONS,
  MARK_NOTIFICATION_SUCCESS,
  CLEAR_RECEIVE_DISBURSE_AMOUNT,
  CLEAR_RECEIVE_TRANSFER_FUNDS_TO_ACH,
  CLEAR_RECEIVE_TRANSFER_FUNDS_TO_CARD,
  CLEAR_GET_DEBIT_WALLET_BALANCE,
  ADD_USER_CARD,
  RECEIVE_ADD_USER_CARD,
  ADD_BUSINESS_USER_CARD,
  RECEIVE_ADD_BUSINESS_USER_CARD,
  LINK_CARD_PROFILE_PAGE,
  RECIEVE_LINK_CARD_PROFILE_PAGE,
  RECIEVE_GET_ADDED_CARDS_FOR_USER,
  GET_ADDED_CARDS_FOR_USER,
  GET_ALL_ADDED_CARDS_FOR_USER,
  RECIEVE_GET_ALL_ADDED_CARDS_FOR_USER,
  TUTORIAL_POPUP_STATE_ACTION_2,
  TUTORIAL_POPUP_STATE_ACTION_3,
  TUTORIAL_POPUP_STATE_ACTION_4,
  TUTORIAL_POPUP_STATE_ACTION_5,
  TUTORIAL_POPUP_STATE_ACTION,
  CLEAR_TUTORIAL_POPUP_STATE_ACTION_2,
  CLEAR_TUTORIAL_POPUP_STATE_ACTION_3,
  CLEAR_TUTORIAL_POPUP_STATE_ACTION_4,
  CLEAR_TUTORIAL_POPUP_STATE_ACTION_5,
  CLEAR_TUTORIAL_POPUP_STATE_ACTION,
  CLEAR_RECEIVE_UPDATE_BANK_ACCOUNT_DETAILS,
  CLEAR_RECEIVE_UPDATE_CARD_DETAILS,
  RECEIVE_GET_SETTLEMENT_LIST_FOR_GROUP,
  GET_SETTLEMENT_LIST_FOR_GROUP,
  GET_SETTLEMENT_DETAIL_FOR_GROUP,
  RECEIVE_GET_SETTLEMENT_DETAIL_FOR_GROUP,
  RECEIVE_GET_ENROLLED_LIST_BY_SEARCH_AND_FILTER_FOR_GROUP,
} from "../Actions/actions";
import moment from 'moment'

const istate = {
  userInfo: localStorage.getItem('user')
    ? {
        user: JSON.parse(localStorage.getItem('user')),
        userId: JSON.parse(localStorage.getItem('userId')),
        roleName: localStorage.getItem('roleName'),
        userObject: JSON.parse(localStorage.getItem('userObject')),
      }
    : [],
  profileName: localStorage.getItem('profileName')
    ? localStorage.getItem('profileName')
    : [],
  AllStates: [],
  pageName: '',
  autoPartDefendentParts: [],
  ForgetPasswordData: [],
  AllPlansForMember: {},
  ConfirmUserEmailData: [],
  ResetPasswordData: [],
  BusinessData: [],
  IndustryData: [],
  allEnrichmentQuestion: {},
  AllSettlement: {},
  AllCategory: [],
  EnrollSettlementForUser: {},
  AlLFeatureSettlement: {},
  savedEnrichmentQuestionResponse: {},
  ConsumerUserData: [],
  autoUdateUser: [],
  BusinessUserProfileData: [],
  BusinessUserProfileDataAffilate: [],
  planUpdate: [],
  BusinessUpdateUserProfileData: [],
  ConsumerUpdateProfileData: [],
  ChidCompanyData: [],
  CognitoEmail: [],
  ConfirmCognitoUserEmailData: [],
  ViewChidCompanyData: [],
  DeleteChidCompanyData: [],
  SaveChidCompanyData: [],
  UpdateChidCompanyData: [],
  AllCountryData: [],
  AllStateData: [],
  AllCityData: [],
  GetAffiliateUser: [],
  GetAffiliateSubUser: [],
  receiveAllGroupsByParentAffiliateUser: [],
  receiveAllPartnerByGroup: [],
  receiveAllHierarchyChildAffiliateUsersByParentAffiliateUser : [],
  receiveGetAffiliateGroup :[],
  receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer: [],
  getSettlementListForGroup: {},
  receiveGetSettlementListForGroup: {},
  GetBusinessSubUser: [],
  GetAllPlainConsumer: [],
  GetAffiliateSubUserList: [],
  GetBusinessSubUserList: [],
  GetDeletedAffiliateSubUser: [],
  GetDeletedBusinessSubUser: [],
  AllAttentionSettlement: {},
  AllCompleteSettlement: {},
  settlementQuestionList: {},
  ReciveSettlmentanswersResponse: {},
  UploadENrolmentDocResponse: {},
  UpdateUploadENrolmentDocResponse: [],
  emailVerifyData: {},
  affiliateUserTypeArray: [],
  affiliateSubUserDataById: [],
  businessSubUserDataById: [],
  affiliateSubUserUpdatedData: [],
  businessSubUserUpdatedData: [],
  enrolmentAuthdata: {},
  completedSettlements: {},
  notificationCount: {},
  notificationMarkCount: {},
  vehicleYear: [],
  vehicleData: [],
  setFilteredSettlement: [],
  setFilteredDSettlement: [],
  vehicleMake: [],
  vehicleMoel: [],
  vehicleTrim: [],
  uploadDOcData: [],
  vehicleUserData: [],
  vehicleDeleteData: [],
  vehicleViewData: [],
  deleteResidenceData: [],
  updateResidence: [],
  addVehicle: {},
  saveResidence: [],
  receiveDismissSettlement: [],
  setEnrolledFilteredSettlement: {},
  pendingSettlementDOc: {},
  faqCategory: [],
  faqQuestions: [],
  pageDetails: [],
  userByIdentityKey: {},
  acceptDocument: {},
  setDismissSettlement: [],
  uploadSuccessFully: [],
  questonUploadFile :[],
  deleteUploadFile : [],
  changePassword: [],
  saveSettlementWithoutData: [],
  plansDataAffiliate: [],
  settlementDataAffiliate: [],
  settlementRefeDataAffiliateData: [],
  settlementEnrolledDataAffiliateData: [],
  getEnrolledListBySearchAndFilterForGroupData: [],
  settlementUserIdAffiliateData: [],
  receiveAllSettlementListOfUserByIdForGroup: [],
  barGraphData: [],
  parentBarGraphData: [],
  parentLineGraphData : [],
  pieGraphData: [],
  pieGraphStateData: [],
  updateProfileDateA: [],
  nextQuestionDataApi: ['a'],
  nextQuestionSaveDataApi: [],
  backQuestionSaveDataApi: [],
  pendingSettlementDOcUser: [],
  getActivityLogApi: [],
  recievedNotifications: [],
  deleteNotification: {},
  fundTotal: [],
  siteData: [],
  vehicleDataExternal: [],
  vehicleDataExternalSave: [],
  promotedSettlementByUserId: [],
  uploadedChild: [],
  // BusinessUserDataStep1: {},
  fusebillData: [],
  fusebillCountriesDataForCard: [],
  getEnrollmentUserDataCount: [],
  getResourceSections: [],
  getDebitWalletBalance: {},
  getTransactionsHistory: [],
  linkAccountProfile:{},
  recieveLinkAccountProfile:{},
  getTranscardPaymentMethods: {},
  recieveGetTranscardPaymentMethods: {},
  recieveDisburseAmount: {},
  disburseAmount: {},
  receiveTransferFundsToACH: {},
  receiveTransferFundsToCard: {},
  transferFundsToACH: {},
  transferFundsToCard: {},
  receiveAddUserBankAccountApi: {},
  addUserBankAccount: {},
  getAddedBankAccountsForUser: {},
  getCollectedSettlementsHistoryForUser: {},
  receiveGetCollectedSettlementsHistoryForUser: {},
  receiveGetUserTransactionsHistory: {},
  receiveGetAddedBankAccountsForUser: {},
  deleteUserBankAccount: {},
  receiveDeleteUserBankAccount: {},
  deleteUserCard: {},
  receiveDeleteUserCard: {},
  setDefaultBankAccount: {},
  receiveSetDefaultBankAccount: {},
  receiveSetDefaultCard: {},
  showNetAmountToUser: {},
  receiveShowNetAmountToUser: {},
  updateBankAccountDetails: {},
  receiveUpdateBankAccountDetails: {},
  updateCardDetails: {},
  receiveUpdateCardDetails: {},
  affiliateDashboardDataForparent: [],
  markAllReadNotification: {},
  markNotificationSuccess: {},
  addUserCard: {},
  receiveAddUserCard: {},
  addBusinessUserCard: {},
  receiveAddBusinessUserCard: {},
  createTranscardCard: {},
  receiveTranscardCardApi: {},
  getAddedCardsForUser: {},
  receiveGetAddedCardsForUser: {},
  tutorialPopupStateAction2: {},
  tutorialPopupStateAction3: {},
  tutorialPopupStateAction4: {},
  tutorialPopupStateAction5: {},
  tutorialPopupStateAction: {},
  clearTutorialPopupStateAction: {},
  receiveDisbursePayment: {},
  getAffiliateGroupReducer: {},
  // profileName:{},
  phase: "loading",
};
export const initialState = Immutable.from(istate);
export default (state = initialState, { type, data }) => {

  switch (type) {
    case RECEIVE_API_DATA:
      return state.set('userInfo', data);

    case RECEIVE_API_DATA_PROFILE:
      return state.set('profileName', data);

    case RECEIVE_AFFILIATE_RESOURCE:
      return state.set('getResourceSections', data);

    case SET_PAGE_NAME:
      return state.set('pageName', data);

    case RECEIVE_TRANSACTIONS_HISTORY:
      return state.set('getTransactionsHistory', data);
    case RECEIVE_DEBIT_WALLET_BALANCE:
      return state.set('getDebitWalletBalance', data);
      case RECEIVE_GET_AFFILIATE_GROUP_SUCCESS:
        return state.set("getAffiliateGroupReducer", data);
    case RECEIVE_FUSEBILL_DATA:
      return state.set('fusebillData', data);
    case RECEIVE_FUSEBILL_PAYMENT_METHOD:
      return state.set('fusebillData', data);
    case RECEIVE_FUSEBILL_CARD_ID:
      return state.set('fusebillData', data);
    case RECEIVE_FUSEBILL_COUNTRIES_DATA_FOR_CARD:
      return state.set('fusebillCountriesDataForCard', data);
    case RECEIVE_BUSINESS_USER_DATA:
      return state.set('BusinessUserData', data);

    case RECEIVE_BUSINESS_USER_DATA_PARTNER:
      return state.set('BusinessUserData', data);

    case RECEIVE_DEFENDENT_AUTO_DATA:
      return state.set('autoPartDefendentParts', data);

    case RECEIVE_ALL_STATES:
      return state.set('AllStates', data);

    case RECEIVE_FORGET_PASSWORD_DATA:
      return state.set('ForgetPasswordData', data);

    case RECEIVE_ALL_PLANES:
      return state.set('AllPlansForMember', data);

    case RECEIVE_USER_EMAIL_DATA:
      return state.set('ConfirmUserEmailData', data);

    case RECEIVE_REQUEST_RESET_PASSWORD:
      return state.set('ResetPasswordData', data);

    case RECEIVE_BUSINESS_DATA:
      return state.set('BusinessData', data);

    case RECEIVE_INDUSTRY_DATA:
      return state.set('IndustryData', data);

    case RECEIVE_SETTLEMENT_ENRICH_QUE:
      return state.set('allEnrichmentQuestion', data);
    case RECEIVE_ALL_SETTLEMENT:
      return state.set('AllSettlement', data);
    case RECEIVE_ALL_CATEGORY:
      return state.set('AllCategory', data);
    case RECEIVE_SETTLEMENT_FOR_USER:
      return state.set('EnrollSettlementForUser', data);
    case RECEIVE_ALL_FEATURE_SETTLEMENT:
      return state.set('AlLFeatureSettlement', data);
    case RECEIVE_ALL_ATTENTION_SETTLEMENT:
      return state.set('AllAttentionSettlement', data);
      case RECEIVE_ALL_COMPLETE_SETTLEMENT:
      return state.set('AllCompleteSettlement', data);
    case RECEIVE_SAVE_ENRICHMENT_QUESTION:
      return state.set('savedEnrichmentQuestionResponse', data);
    case RECEIVE_CONSUMERUSER_DATA:
      return state.set('ConsumerUserData', data);
    case RECEIVE_AUTO_UPDATE_DATA:
      return state.set('autoUdateUser', data);
    case RECEIVE_CONSUMER_USER_DATA:
      return state.set('RecieveConsumerUserData', data);
    case RECEIVE_BUSINESSUSER_DATA:
      return state.set('BusinessUserProfileData', data);
    case RECEIVE_BUSINESSUSER_DATA_AFFI:
      return state.set('BusinessUserProfileDataAffilate', data);
    case RECEIVE_PLAN_PRICE_CHANGE:
      return state.set('planUpdate', data);

    case RECEIVE_AFFILIATE_USER_TYPE_SIGNUP:
      return state.set('affilateUserList', data);

    case RECEIVE_BUSINESSUPDATE_DATA:
      return state.set('BusinessUpdateUserProfileData', data);
    case RECEIVE_CONSUMERUPDATE_DATA:
      return state.set('ConsumerUpdateProfileData', data);
    case RECEIVE_CHILDCOMPAY_DATA:
      return state.set('ChidCompanyData', data);
    case RECEIVE_COGNITO_ID_BY_EMAIL:
      return state.set('CognitoEmail', data);
    case RECEIVE_CONFIRM_EMAIL_COGNITO:
      return state.set('ConfirmCognitoUserEmailData', data);
    case RECEIVE_DELETE_BUSINESSCOMPANY_DATA:
      return state.set('DeleteChidCompanyData', data);
    case RECEIVE_VIEW_BUSINESSCOMPANY_DATA:
      return state.set('ViewChidCompanyData', data);
    case RECEIVE_BUSINESSCOMPANY_DATA:
      return state.set('SaveChidCompanyData', data);
    case RECEIVE_BUSINESSCOMPANY_UPDATE_DATA:
      return state.set('UpdateChidCompanyData', data);
    case RECEIVE_COUNTRY_DATA:
      return state.set('AllCountryData', data);
    case RECEIVE_STATEID_DATA:
      return state.set('AllStateData', data);
    case RECEIVE_CITYID_DATA:
      return state.set('AllCityData', data);
    case RECEIVE_AFFILIATE_DATA:
      return state.set('GetAffiliateUser', data);
    case RECEIVE_AFFILIATESUBUSER_DATA:
      return state.set("GetAffiliateSubUser", data);
    case RECEIVE_GET_ALL_GROUPS_BY_PARENT_AFFILIATE_USER:
      return state.set("receiveAllGroupsByParentAffiliateUser", data);
      case RECEIVE_GET_ALL_PARTNERS_BY_GROUP:
      return state.set("receiveAllPartnerByGroup", data);
    case RECEIVE_ALL_HIERARCHY_CHILD_AFFILIATE_USERS_BY_PARENT_AFFILIATE_USER : 
      return state.set("receiveAllHierarchyChildAffiliateUsersByParentAffiliateUser",data)
    case RECEIVE_GET_AFFILIATE_GROUP_SUCCESS : 
    return state.set("receiveGetAffiliateGroup",data)
   case RECEIVE_GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER_FOR_GROUP:
      return state.set("receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer", data);
    case RECEIVE_BUSINESSSUBUSER_DATA:
      return state.set('GetBusinessSubUser', data);
    case RECEIVE_CLEAR_BUSINESSSUBUSER_DATA:
      return state.set('GetBusinessSubUser', []);

    case RECEIVE_SETTLEMENT_QUESTION_ID:
      return state.set('settlementQuestionList', data);
    case RECEIVE_PENDING_SETTLEMENT_QUESTION_ID:
      return state.set('settlementQuestionList', data);
    case RECEIVE_ALL_CONSUMER_PLANES:
      return state.set('GetAllPlainConsumer', data);
    case RECEIVE_AFFILIATESUBUSERLIST_DATA:
      return state.set('GetAffiliateSubUserList', data);
    case RECEIVE_BUSINESSSUBUSERLIST_DATA:
      return state.set('GetBusinessSubUserList', data);
    case RECEIVE_DELETE_AFFILIATESUBUSER_DATA:
      return state.set('GetDeletedAffiliateSubUser', data);
    case RECEIVE_DELETE_BUSINESSSUBUSER_DATA:
      return state.set('GetDeletedBusinessSubUser', data);
    case RECEIVE_SETTLEMENT_ANSWERS:
      return state.set('ReciveSettlmentanswersResponse', data);
    case RECEIVE_ENROLMENT_DOC:
      return state.set('UploadENrolmentDocResponse', data);
    case RECEIVE_UPDATE_ENROLMENT_DOC:
      return state.set('UpdateUploadENrolmentDocResponse', data);
    case RECEIVE_EMAIL_VERIFY:
      return state.set('emailVerifyData', data);
    case RECEIVE_AFFILIATE_USER_TYPE:
      return state.set('affiliateUserTypeArray', data);
    case RECEIVE_SUBUSERBYID_TYPE:
      return state.set('affiliateSubUserDataById', data);
    case RECEIVE_BUSINESSSUBUSERBYID_TYPE:
      return state.set('businessSubUserDataById', data);
    case RECEIVE_UPDATEAFFILIATESUBUSER_TYPE:
      return state.set('affiliateSubUserUpdatedData', data);
    case RECEIVE_UPDATEBUSINESSSUBUSER_TYPE:
      return state.set('businessSubUserUpdatedData', data);
    case RECEIVE_ENROLMENT_AUTH:
      return state.set('enrolmentAuthdata', data);
    case RECEIVE_COMPLETED_SETTLEMENTS:
      return state.set('completedSettlements', data);
    case RECEIVE_CONSUMER_RESIDENCE:
      return state.set('consumerResidence', data);
    case RECEIVE_ALL_VEHICLE_YEAR:
      return state.set('vehicleYear', data);
    case RECEIVE_PENDING_DOCS:
      return state.set('pendingSettlementDOc', data);
    case RECEIVE_ALL_VEHICLE_DATA:
      return state.set('vehicleData', data);

    case RECEIVE_NOTIFICATION_DATA:
      return state.set('notificationCount', data);

    case RECIEVE_MARK_NOTIFICATIONS:
      return state.set('notificationMarkCount', data);

    case RECEIVE_ALL_VEHICLE_DATA_SETTLEMENT:
      return state.set('vehicleDataSettlement', data);
    case RECEIVE_ALL_FILTEREDSETTLEMENT:
      return state.set('setFilteredSettlement', data);
    case RECEIVE_ALL_DASHBOARD_FILTEREDSETTLEMENT:
      return state.set('setFilteredDSettlement', data);

    case RECEIVE_SAVE_MULTIPLE_VEHICLE_QUESTION_DATA:
      return state.set('recievedDataList', data);

    // return { ...state, setFilteredSettlement: data };
    case RECEIVE_ALL_ENROLLEDSETTLEMENT:
      return state.set('setEnrolledFilteredSettlement', data);
    // return { ...state, setEnrolledFilteredSettlement: data };
    case RECEIVE_VEHICLE_MAKE_DATA:
      return state.set('vehicleMake', data);
    case RECEIVE_VEHICLE_MODEL_DATA:
      return state.set('vehicleMoel', data);
    case RECEIVE_VEHICLE_TRIM_DATA:
      return state.set('vehicleTrim', data);
    case RECEIVE_UPLOADFILE_DATA_DOC:
      return state.set('uploadDOcData', data);
    case RECEIVE_VEHICLE_DATA_USERID_DATA:
      return state.set('vehicleUserData', data);
    case RECEIVE_DELETE_VEHICLE_DATA_USERID_DATA:
      return state.set('vehicleDeleteData', data);
    case RECEIVE_VIEW_VEHICLE_DATA_USERID_DATA:
      return state.set('vehicleViewData', data);
    case RECEIVE_DELETE_CONSUMER_RESIDENCE:
      return state.set('deleteResidenceData', data);
    case RECEIVE_VIEW_CONSUMER_RESIDENCE:
      return state.set('updateResidence', data);
    case RECEIVE_VEHICLE_SAVE_DATA:
      return state.set('addVehicle', data);
    case RECEIVE_SAVE_RESIDENCE_DATA:
      return state.set('saveResidence', data);
    case RECEIVE_DISMISS_SETTLEMENT:
      return state.set('receiveDismissSettlement', data);
    case RECEIVE_FAQ_CATEGORY:
      return state.set('faqCategory', data);

    case RECEIVE_FAQ_QUESTIONS_BY_CATEGORY_ID:
      return state.set('faqQuestions', data);

    case RECEIVE_PAGE_DATA:
      return state.set('pageDetails', data);

    case RECEIVE_PAGE_DATA_FOOTER:
      return state.set('pageDetailsFooter', data);

    case RECEIVE_PAGE_DATA_IDENTITY_KEY:
      return state.set('userByIdentityKey', data);

    case RECEIVE_ACCEPT_DOCUMENT:
      return state.set('acceptDocument', data);

    case RECEIVE_AFFILIATE_DASHBOARD_DATA:
      return state.set("affiliateDashboardData", data);
      
    case RECEIVE_GET_AFFILIATE_DASHBOARD_USER_FOR_PARENT:
          return state.set("affiliateDashboardDataForparent", data);

    case RECEIVE_DISMISS_SETTLEMENT_FOR_USER:
      return state.set('setDismissSettlement', data);
    case RECEIVE_REGISTRATION_LINKS_FOR_USER:
      return state.set('setRegistrationLinksForUser', data);
    case RECEIVE_UPLOADFILE_DATA:
      return state.set('uploadSuccessFully', data);
    case RECEIVE_QUESTION_TYPE_FILE : 
      return state.set('questonUploadFile',data);
    case RECEIVE_QUESTION_TYPE_FILE_DELETE :
      return state.set('deleteUploadFile',data);
    case RECEIVE_SETTLEMENT_WITHOUT_DATA:
      return state.set('saveSettlementWithoutData', data);
    case RECEIVE_CHANGE_PASSWORD_DATA:
      return state.set('changePassword', data);
    case RECEIVE_DETAIL_BYAFFILIATEKEY:
      return state.set('plansDataAffiliate', data);
    case RECEIVE_ALL_FILTEREDSETTLEMENT_AFFILIATE:
      return state.set('settlementDataAffiliate', data);
    case SUCCESS:
      return state.set('phase', 'SUCCESS');
    case RECEIVE_ALL_REFERRED_FILTEREDSETTLEMENT_AFFILIATEID:
      return state.set('settlementRefeDataAffiliateData', data);
    case RECEIVE_ALL_ENROLLED_FILTEREDSETTLEMENT_AFFILIATEID:
      return state.set("settlementEnrolledDataAffiliateData", data);
   case RECEIVE_GET_ENROLLED_LIST_BY_SEARCH_AND_FILTER_FOR_GROUP:
      return state.set("getEnrolledListBySearchAndFilterForGroupData", data);
    case RECEIVE_ALL_USER_SETTLEMENT_AFFILIATEID:
      return state.set("settlementUserIdAffiliateData", data);
    case RECEIVE_ALL_SETTLEMENT_LIST_OF_USER_BY_ID_FOR_GROUP:
      return state.set("getAllSettlementListOfUserByIdForGroupData", data);
    case RECEIVE_BAR_DASHBOARD_DATA:
      return state.set("barGraphData", data);
    case RECEIVE_GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER:
      return state.set("parentBarGraphData", data);
    case RECEIVE_MONTHLY_ENROLLMENTS_BY_AFFILIATE_GROUP :
      return state.set("parentLineGraphData",data);
    case RECEIVE_PIE_DASHBOARD_DATA:
      return state.set('pieGraphData', data);
    case RECEIVE_PIE_DASHBOARD_STATE_DATA:
      return state.set('pieGraphStateData', data);

    case RECEIVE_UPDATE_AFFILIATE_DATA:
      return state.set('updateProfileDateA', data);
    case RECEIVE_APPLY_NEXT_QUESTION:
      return state.set('nextQuestionDataApi', data);
    case RECEIVE_SAVE_APPLY_NEXT_QUESTION:
      return state.set('nextQuestionSaveDataApi', data);
    case RECEIVE_ALL_ELIGIBILITY_BACK:
      return state.set('backQuestionSaveDataApi', data);
    case RECEIVE_ACTIVITY_LOG:
      return state.set('getActivityLogApi', data);
    case RECEIVE_PENDING_DOCS_USER:
      return state.set('pendingSettlementDOcUser', data);
    case RECEIVE_PENDING_DOCS_USER_DELETE:
      return state.set('pendingSettlementDOcUserDelete', data);

    case RECIEVE_ALL_NOTIFICATIONS:
      return state.set('recievedNotifications', data);
    case DELETE_NOTIFICATION_SUCCESS:
      return state.set("deleteNotification", data);
    case RECEIVE_ALL_TOTAL_FUND_DATA:
      return state.set('fundTotal', data);
    case RECEIVE_ALL_SITE:
      return state.set('siteData', data);
    case LOGOUT_USER:
      state = state.set('recieveLinkAccountProfile', {});
      return state.set('userInfo', []);
    case RECEIVE_ALL_EXTERNAL_VEHICLE_DATA:
      return state.set('vehicleDataExternal', data);
    case RECEIVE_SAVE_MULTIPLE_VEHICLE_DATA:
      return state.set('vehicleDataExternalSave', data);
    case RECEIVE_ALL_PROMOTED_SETTLEMENT:
      return state.set('promotedSettlementByUserId', data);
    case RECIEVE_UPLOADED_CHILD_COMPANY:
      return state.set('uploadedChild', data);
    case RECEIVE_DASHBOARD_DATA:
      return state.set('getDashboardData', data);
    case RECEIVE_DASHBOARD_DATA_COUNT:
      return state.set('getDashboardDataCount', data);

    case GET_SETTLEMENT_LIST_FOR_GROUP:
          return state.set("getSettlementListForGroup", data);
    case RECEIVE_GET_SETTLEMENT_LIST_FOR_GROUP:
      return state.set("receiveGetSettlementListForGroup", data);

    case GET_SETTLEMENT_DETAIL_FOR_GROUP:
          return state.set("getSettlementDetailForGroup", data);
    case RECEIVE_GET_SETTLEMENT_DETAIL_FOR_GROUP:
      return state.set("receiveGetSettlementDetailForGroup", data);

    case RECEIVE_ALL_ENROLLED_AFFILIATEID:
      return state.set('getEnrollmentUserDataCount', data);

    case LINK_ACCOUNT_PROFILE_PAGE: 
    return state.set('linkAccountProfile', data);

    case RECIEVE_LINK_ACCOUNT_PROFILE_PAGE:
      return state.set('recieveLinkAccountProfile', {...(data.data), setAt: moment().valueOf()});

    case GET_TRANSCARD_PAYMENT_METHODS:
      return state.set('getTranscardPaymentMethods', {}); 
    
    case RECIEVE_GET_TRANSCARD_PAYMENT_METHODS:
      return state.set('recieveGetTranscardPaymentMethods', data); 

    case DISBURSE_AMOUNT:
      return state.set('disburseAmount', data);  

    case RECEIVE_DISBURSE_AMOUNT:
      return state.set('recieveDisburseAmount', data);

    case TRANSFER_FUNDS_TO_ACH:
      return state.set('transferFundsToACH', data);   
    
    case RECEIVE_TRANSFER_FUNDS_TO_ACH: 
      return state.set('receiveTransferFundsToACH',data) 
    
    case TRANSFER_FUNDS_TO_CARD:
      return state.set('transferFundsToCard', {});     

    case RECEIVE_TRANSFER_FUNDS_TO_CARD: 
      return state.set('receiveTransferFundsToCard',data)  

    case ADD_USER_BANK_ACCOUNT: 
      return state.set('addUserBankAccount', data)  
    
    case RECIEVE_ADD_USER_BANK_ACCOUNT_PAGE: 
      return state.set('receiveAddUserBankAccountApi', {...(data.data), setAt: moment().valueOf()}) 
    
    case CLEAR_RECEIVE_ADD_USER_BANK_ACCOUNT_API:
      return state.set('receiveAddUserBankAccountApi', {}) 
    
    case CLEAR_RECEIVE_ADD_USER_CARD:
      return state.set('receiveAddUserCard', {})

    case CLEAR_RECEIVE_ADD_BUSINESS_USER_CARD:
      return state.set('receiveAddBusinessUserCard', {})
    
    case GET_ADDED_BANK_ACCOUNT_FOR_USER: 
      return state.set('getAddedBankAccountsForUser', data)  

    case GET_ADDED_CARDS_FOR_USER: 
      return state.set('getAddedCardsForUser', data)  
    
    case RECIEVE_GET_ADDED_CARDS_FOR_USER: 
      return state.set('receiveGetAddedCardsForUser', data) 

    case RECIEVE_GET_ADDED_BANK_ACCOUNT_FOR_USER: 
      return state.set('receiveGetAddedBankAccountsForUser', data) 
    
    case GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER: 
      return state.set('getCollectedSettlementsHistoryForUser', data)   
      
    case RECIEVE_GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER:
      return state.set('receiveGetCollectedSettlementsHistoryForUser', data)  
    
    case GET_ALL_BANK_ACCOUNTS_FOR_USER: 
      return state.set('getAllBankAccountsForUser', data)   
      
    case RECIEVE_GET_ALL_BANK_ACCOUNTS_FOR_USER:
      return state.set('receiveGetAllBankAccountsForUser', data)   
    
    case GET_ALL_ADDED_CARDS_FOR_USER: 
      return state.set('getAllAddedCardsForUser', data)   
      
    case RECIEVE_GET_ALL_ADDED_CARDS_FOR_USER:
      return state.set('receiveGetAllAddedCardsForUser', data)   
    
    case RECIEVE_GET_USER_TRANSACTION_HISTORY: 
      return state.set('receiveGetUserTransactionsHistory', data)    
    
    case DELETE_USER_BANK_ACCOUNT: 
      return state.set('deleteUserBankAccount', data) 

    case RECEIVE_DELETE_USER_BANK_ACCOUNT: 
      return state.set('receiveDeleteUserBankAccount', {...data, setAt: moment().valueOf()})        

    case DELETE_USER_CARD: 
      return state.set('deleteUserCard', data) 

    case RECEIVE_DELETE_USER_CARD: 
      return state.set('receiveDeleteUserCard', {...data, setAt: moment().valueOf()})        

    case SET_DEFAULT_BANK_ACCOUNT: 
      return state.set('setDefaultBankAccount', data) 
      
    case RECEIVE_SET_DEFAULT_BANK_ACCOUNT: 
      return state.set('receiveSetDefaultBankAccount', {...data, setAt: moment().valueOf()})  
    
    case RECEIVE_SET_DEFAULT_CARD: 
      return state.set('receiveSetDefaultCard', {...data, setAt: moment().valueOf()})  
    
    case SHOW_NET_AMOUNT_TO_USER:
      return state.set('showNetAmountToUser', data)
      
    case RECIEVE_SHOW_NET_AMOUNT_TO_USER:
      return state.set('receiveShowNetAmountToUser', data)  

    case UPDATE_CARD_DETAILS:
      return state.set('updateCardDetails', data) 
   
    case RECEIVE_UPDATE_CARD_DETAILS:
      return state.set('receiveUpdateCardDetails', data)     

    case UPDATE_BANK_ACCOUNT_DETAILS:
      return state.set('updateBankAccountDetails', data)  

    case RECEIVE_UPDATE_BANK_ACCOUNT_DETAILS:
      return state.set('receiveUpdateBankAccountDetails', data) 
      return state.set("getEnrollmentUserDataCount", data);

    case CLEAR_RECEIVE_UPDATE_BANK_ACCOUNT_DETAILS:
      return state.set('receiveUpdateBankAccountDetails', {}) 

    case CLEAR_RECEIVE_UPDATE_CARD_DETAILS:
          return state.set('receiveUpdateCardDetails', {}) 

    case MARK_ALL_READ_NOTIFICATIONS:
      return state.set("markAllReadNotification", data);
    case MARK_NOTIFICATION_SUCCESS:
        return state.set("markNotificationSuccess", data);   
    case CLEAR_RECEIVE_DISBURSE_AMOUNT: 
        return state.set('recieveDisburseAmount', {})
    case CLEAR_RECEIVE_TRANSFER_FUNDS_TO_ACH: 
        return state.set('receiveTransferFundsToACH', {})
    case CLEAR_RECEIVE_TRANSFER_FUNDS_TO_CARD: 
        return state.set('receiveTransferFundsToCard', {})
    case CLEAR_GET_DEBIT_WALLET_BALANCE: 
        return state.set('getDebitWalletBalance', {})  
    case ADD_USER_CARD:
        return state.set('addUserCard', {})            
    case RECEIVE_ADD_USER_CARD:
        return state.set('receiveAddUserCard', {...(data), setAt: moment().valueOf()})
    case ADD_BUSINESS_USER_CARD:
        return state.set('addBusinessUserCard', {})            
    case RECEIVE_ADD_BUSINESS_USER_CARD:
        return state.set('receiveAddBusinessUserCard', {...(data), setAt: moment().valueOf()})
    case LINK_CARD_PROFILE_PAGE:
        return state.set('createTranscardCard', {})
    case RECIEVE_LINK_CARD_PROFILE_PAGE:
      return state.set('receiveTranscardCardApi', {...(data.data), setAt: moment().valueOf()});  
    case TUTORIAL_POPUP_STATE_ACTION_2:
        return state.set("tutorialPopupStateAction2", data);   
    case TUTORIAL_POPUP_STATE_ACTION_3:
        return state.set("tutorialPopupStateAction3", data);
    case TUTORIAL_POPUP_STATE_ACTION_4:
        return state.set("tutorialPopupStateAction4", data);   
    case TUTORIAL_POPUP_STATE_ACTION_5:
        return state.set("tutorialPopupStateAction5", data);   
    case TUTORIAL_POPUP_STATE_ACTION:
        return state.set("tutorialPopupStateAction", data);     
    case CLEAR_TUTORIAL_POPUP_STATE_ACTION_2:
        return state.set("tutorialPopupStateAction2", {});   
    case CLEAR_TUTORIAL_POPUP_STATE_ACTION_3:
        return state.set("tutorialPopupStateAction3", {});   
    case CLEAR_TUTORIAL_POPUP_STATE_ACTION_5:
        return state.set("tutorialPopupStateAction5", {});   
    case CLEAR_TUTORIAL_POPUP_STATE_ACTION_4:
        return state.set("tutorialPopupStateAction4", {});   
    case CLEAR_TUTORIAL_POPUP_STATE_ACTION:
        return state.set("tutorialPopupStateAction", {});   

    // promotedSettlementByUserId
    default:
      return state;
  }
};
